import VisibilityTypes from './VisibilityTypes';

export const getSupplierType = (payload) => {
  return {
    type: VisibilityTypes.GET_SUPPLIER_TYPES,
    payload,
  };
};

export const getSupplierTypeSuccess = (payload) => {
  return {
    type: VisibilityTypes.GET_SUPPLIER_TYPES_SUCCESS,
    payload,
  };
};

export const getSupplierTypeError = (payload) => {
  return {
    type: VisibilityTypes.GET_SUPPLIER_TYPES_ERROR,
    payload,
  };
};

export const getSearchVisibilityList = (payload) => {
  return {
    type: VisibilityTypes.GET_VISIBILITY_SEARCH_LIST,
    payload,
  };
};

export const updateSearchVisibilityList = (payload) => {
  return {
    type: VisibilityTypes.UPDATE_VISIBILITY_SEARCH_LIST,
    payload,
  };
};

export const updateSearchVisibilityListSuccess = (payload) => {
  return {
    type: VisibilityTypes.UPDATE_VISIBILITY_SEARCH_LIST_SUCCESS,
    payload,
  };
};

export const getSearchVisibilityListSuccess = (payload) => {
  return {
    type: VisibilityTypes.GET_VISIBILITY_SEARCH_LIST_SUCCESS,
    payload,
  };
};

export const getSearchVisibilityListError = (payload) => {
  return {
    type: VisibilityTypes.GET_VISIBILITY_SEARCH_LIST_FAIL,
    payload,
  };
};

export const getSearchVisibilityListClear = () => {
  return {
    type: VisibilityTypes.GET_VISIBILITY_SEARCH_LIST_CLEAR,
  };
};

export const getSearchVisibilitySetDataList = (payload) => {
  return {
    type: VisibilityTypes.GET_VISIBILITY_SET_SEARCH_LIST_DATA,
    payload,
  };
};

export const getTrackingStatusDetails = (payload) => {
  return {
    type: VisibilityTypes.GET_TRACKING_STATUS_DETAILS,
    payload,
  };
};

export const getTrackingStatusDetailsSuccess = (payload) => {
  return {
    type: VisibilityTypes.GET_TRACKING_STATUS_DETAILS_SUCCESS,
    payload,
  };
};

export const getTrackingStatusDetailsError = (payload) => {
  return {
    type: VisibilityTypes.GET_TRACKING_STATUS_DETAILS_FAIL,
    payload,
  };
};

export const getVisibilityProductInfo = (payload) => {
  return {
    type: VisibilityTypes.GET_VISIBILITY_PRODUCT_INFO,
    payload,
  };
};

export const getVisibilityProductInfoSuccess = (payload) => {
  return {
    type: VisibilityTypes.GET_VISIBILITY_PRODUCT_INFO_SUCCESS,
    payload,
  };
};

export const getVisibilityProductInfoFail = (payload) => {
  return {
    type: VisibilityTypes.GET_VISIBILITY_PRODUCT_INFO_FAIL,
    payload,
  };
};

export const getShipmentNotesAndDetails = (payload) => {
  return {
    type: VisibilityTypes.GET_SHIPMENT_NOTES_AND_DETAILS,
    payload,
  };
};

export const getShipmentNotesAndDetailsSuccess = (payload) => {
  return {
    type: VisibilityTypes.GET_SHIPMENT_NOTES_AND_DETAILS_SUCCESS,
    payload,
  };
};

export const getShipmentNotesAndDetailsFail = (payload) => {
  return {
    type: VisibilityTypes.GET_SHIPMENT_NOTES_AND_DETAILS_FAIL,
    payload,
  };
};

export const getShipperConsigneeDetails = (payload) => {
  return {
    type: VisibilityTypes.GET_SHIPPER_AND_CONSIGNEE_DETAILS,
    payload,
  };
};

export const getShipperConsigneeDetailsSuccess = (payload) => {
  return {
    type: VisibilityTypes.GET_SHIPPER_AND_CONSIGNEE_DETAILS_SUCCESS,
    payload,
  };
};

export const getShipperConsigneeDetailsFail = (payload) => {
  return {
    type: VisibilityTypes.GET_SHIPPER_AND_CONSIGNEE_DETAILS_FAIL,
    payload,
  };
};

export const getTransportationProvider = (payload) => {
  return {
    type: VisibilityTypes.GET_TRANSPORTATION_PROVIDER,
    payload,
  };
};

export const getTransportationProviderSuccess = (payload) => {
  return {
    type: VisibilityTypes.GET_TRANSPORTATION_PROVIDER_SUCCESS,
    payload,
  };
};

export const getTransportationProviderFail = (payload) => {
  return {
    type: VisibilityTypes.GET_TRANSPORTATION_PROVIDER_FAIL,
    payload,
  };
};

export const updateShipmentTrackingDetails = (payload) => {
  return {
    type: VisibilityTypes.UPDATE_SHIPMENT_TRACKING_DETAILS,
    payload,
  };
};

export const updateShipmentTrackingDetailsSuccess = (payload) => {
  return {
    type: VisibilityTypes.UPDATE_SHIPMENT_TRACKING_DETAILS_SUCCESS,
    payload,
  };
};

export const updateShipmentTrackingDetailsFail = (payload) => {
  return {
    type: VisibilityTypes.UPDATE_SHIPMENT_TRACKING_DETAILS_FAIL,
    payload,
  };
};

export const updateShipmentTrackingDetailsClear = () => {
  return {
    type: VisibilityTypes.UPDATE_SHIPMENT_TRACKING_DETAILS_CLEAR,
  };
};

export const getVisibilityExceptionReq = (payload) => {
  return {
    type: VisibilityTypes.GET_VISIBILITY_EXCEPTION,
    payload,
  };
};

export const getVisibilityExceptionSuccess = (payload) => {
  return {
    type: VisibilityTypes.GET_VISIBILITY_EXCEPTION_SUCCESS,
    payload,
  };
};

export const getVisibilityExceptionFail = (payload) => {
  return {
    type: VisibilityTypes.GET_VISIBILITY_EXCEPTION_FAIL,
    payload,
  };
};

export const getVisibilityExceptionClear = () => {
  return {
    type: VisibilityTypes.GET_VISIBILITY_EXCEPTION_CLEAR,
  };
};

export const addNewFileBtn = (payload) => {
  return {
    type: VisibilityTypes.ADD_NEW_FILE_ACTION,
    payload,
  };
};

export const addNewTrackingStatusBtn = (payload) => {
  return {
    type: VisibilityTypes.ADD_NEW_TRACKING_STATUS_ACTION,
    payload,
  };
};

export const editGeneralBtn = (payload) => {
  return {
    type: VisibilityTypes.EDIT_GENETRAL_BTN_ACTION,
    payload,
  };
};

export const editDetailsBtn = (payload) => {
  return {
    type: VisibilityTypes.EDIT_DETAILS_BTN_ACTION,
    payload,
  };
};

export const getFooterContentReq = (payload) => {
  return {
    type: VisibilityTypes.GET_FOOTER_CONTENT,
    payload,
  };
};

export const getFooterContentSuccess = (payload) => {
  return {
    type: VisibilityTypes.GET_FOOTER_CONTENT_SUCCESS,
    payload,
  };
};

export const getFooterContentFail = (payload) => {
  return {
    type: VisibilityTypes.GET_FOOTER_CONTENT_FAIL,
    payload,
  };
};

export const setSelectedVisibility = (payload) => {
  return {
    type: VisibilityTypes.SET_SELECTED_VISIBILITY,
    payload,
  };
};
export const clearSelectedVisibility = (payload) => {
  return {
    type: VisibilityTypes.CLEAR_SELECTED_VISIBILITY,
    payload,
  };
};

export const getVisibilityExcelData = (payload) => {
  return {
    type: VisibilityTypes.GET_VISIBILITY_EXCEL_DATA,
    payload,
  };
};

export const getVisibilityExcelDataSuccess = (payload) => {
  return {
    type: VisibilityTypes.GET_VISIBILITY_EXCEL_DATA_SUCCESS,
    payload,
  };
};

export const getVisibilityExcelDataError = (payload) => {
  return {
    type: VisibilityTypes.GET_VISIBILITY_EXCEL_DATA_FAIL,
    payload,
  };
};

export const sendEmailVisibility = (payload) => {
  return {
    type: VisibilityTypes.SENT_EMAIL_VISIBILITY,
    payload,
  };
};

export const sendEmailVisibilitySuccess = (payload) => {
  return {
    type: VisibilityTypes.SENT_EMAIL_VISIBILITY_SUCCESS,
    payload,
  };
};

export const sendEmailVisibilityError = (payload) => {
  return {
    type: VisibilityTypes.SENT_EMAIL_VISIBILITY_FAIL,
    payload,
  };
};

export const getVisibilityExportDetails = (payload) => {
  return {
    type: VisibilityTypes.GET_VISIBILITY_EXPORT_DETAILS,
    payload,
  };
};

export const getVisibilityExportDetailSuccess = (payload) => {
  return {
    type: VisibilityTypes.GET_VISIBILITY_EXPORT_DETAILS_SUCCESS,
    payload,
  };
};

export const getVisibilityExportDetailsFail = (payload) => {
  return {
    type: VisibilityTypes.GET_VISIBILITY_EXPORT_DETAILS_FAIL,
    payload,
  };
};

export const updateRefandDockNoInProgress = (payload) => {
  return {
    type: VisibilityTypes.UPDATE_REF_AND_DOCK_NO,
    payload,
  };
};

export const updateRefandDockNoSuccess = (payload) => {
  return {
    type: VisibilityTypes.UPDATE_REF_AND_DOCK_NO_SUCCESS,
    payload,
  };
};

export const updateRefandDockNoFail = (payload) => {
  return {
    type: VisibilityTypes.UPDATE_REF_AND_DOCK_NO_FAIL,
    payload,
  };
};

export const updateShipmentNoteInProgress = (payload) => {
  return {
    type: VisibilityTypes.UPDATE_SHIPMENT_NOTE,
    payload,
  };
};

export const updateShipmentNoteSuccess = (payload) => {
  return {
    type: VisibilityTypes.UPDATE_SHIPMENT_NOTE_SUCCESS,
    payload,
  };
};

export const updateShipmentNoteFail = (payload) => {
  return {
    type: VisibilityTypes.UPDATE_SHIPMENT_NOTE_FAIL,
    payload,
  };
};

export const updateShipmentDetailsInProgress = (payload) => {
  return {
    type: VisibilityTypes.UPDATE_SHIPMENT_DETAILS,
    payload,
  };
};

export const updateShipmentDetailsSuccess = (payload) => {
  return {
    type: VisibilityTypes.UPDATE_SHIPMENT_DETAILS_SUCCESS,
    payload,
  };
};

export const updateShipmentDetailsFail = (payload) => {
  return {
    type: VisibilityTypes.UPDATE_SHIPMENT_DETAILS_FAIL,
    payload,
  };
};

export const getSuplierData = (payload) => {
  return {
    type: VisibilityTypes.SUPPLIER_TYPE_DATA,
    payload,
  };
};

export const visibilityBranchData = (payload) => {
  return {
    type: VisibilityTypes.BRANCH_DATA,
    payload,
  };
};

export const transportationProviderData = (payload) => {
  return {
    type: VisibilityTypes.TRANSPORTATION_PROVIDER_DATA,
    payload,
  };
};
